import { Button, Col, Layout, Row, Space, Typography } from "antd";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import {LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;
const Welcome = () => {
  const { theme } = useContext(ThemeContext);
  const { Content, Footer } = Layout;
  const { t } = useTranslation();

  return (
    <Layout className="bg-white">
      <CustomHeader />
      <Content className="p-4 pb-0 md:p-6">
        <div className="container mx-auto">
          <Row gutter={[10, 30]}>
            <Col span={24}>
              <Space direction="vertical" className="welcome-block" size={0}>
                <Title level={4} className="text-black welcome-line">
                  {" "}
                  {t("welcome:welcome_to_the_medical_records_request_portal")}
                </Title>
                <Title level={4} className="text-black welcome-sub-line">
                  {/* <Badge color="black" />{" "} */}
                  <span>
                    {t(
                      "welcome:choose_an_option_below_to_begin_your_record_request"
                    )}
                  </span>
                </Title>
              </Space>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 0]}>
                <Space
                  size={10}
                  align="baseline"
                  className="tabs-container justify-around w-full px-1 md:px-5"
                >
                  <div className="tabs-wrapper m-0">
                    <Link to={ROUTES.PATIENT} className={`tabs-item ${theme}`}>
                      <Title level={2} className="text-white font-bold text-center md:text-left">
                        {t("welcome:patient_request")}
                      </Title>
                    </Link>
                    <p className="ps-1 mt-3 !text-center md:!text-left">
                      {t("welcome:patient_request_description")}
                    </p>
                  </div>
                  <div className="tabs-wrapper m-0">
                    <Link to={ROUTES.PARTY_REQUEST} className={`tabs-item ${theme}`}>
                      <Title level={2} className="text-white font-bold text-center md:text-left">
                        {t("welcome:3rd_party_request")}
                      </Title>
                    </Link>
                    <p className="ps-1 mt-3 !text-center md:!text-left">
                      {t("welcome:3rd_party_request_description")}
                    </p>
                  </div>
                </Space>
              </Row>
            </Col>
            <Col span={24} align="center">
              <Space direction="vertical" className="or-information">
                <Space direction="vertical" size={0} style={{ width: "100%" }}>
                  <Title
                    level={4}
                    className="text-black font-normal information-sub-line"
                  >
                    <div className="px-4 mt-[40px] text-center">
                      {/* <Badge color="#000000" /> */}
                      <span>
                        {t("common:if_you_have")}{" "}
                        <u className="font-bold">{t("common:all")}</u>{" "}
                        {t("common:all_required_documents")}
                        &nbsp;<u className="font-bold">
                          {t("common:email")}
                        </u>{" "}
                        {t("common:us_at")}
                      </span>
                      <a
                        className={`font-bold link ${theme}`}
                        href="mailto:requests@provider1st.com"
                      >
                        {" "}
                        {t("common:req_provider_email")}
                      </a>{" "}
                      {t("common:or")}{" "}
                      <u className="font-bold">{t("common:fax")}</u>{" "}
                      {t("common:us_at")}
                      <u className={`${theme}-color font-bold`}>
                        {" "}
                        {t("common:phone_number_dial")}
                      </u>
                      .
                    </div>
                  </Title>
                </Space>
              </Space>
            </Col>
          </Row>
          <Footer className="welcome-footer bg-white p-3 pl-1 md:pl-9">
            <Row>
              <Col span={24}>
                <Title
                  level={2}
                  align="center"
                  className="mt-[50px] !font-[600]"
                >
                  {t(
                    "common:if_you_need_assistance_with_your_request_please_give_us_a_call"
                  )}
                  <u className={`${theme}-color ml-1`}>
                    {t("common:help_phone_number")}
                  </u>
                  .
                </Title>
              </Col>
            </Row>
          </Footer>
          {sessionStorage.getItem("currentActiveClient") !=
          "Trivalley Orthopedics" ? (
            <Space className="w-full mt-8 justify-between" align="baseline">
              <Link to={ROUTES.HOME}>
                <Button type="primary">{t("common:back")}</Button>
              </Link>
            </Space>
          ) : null}

          <Row>
            <Col span={24} className="text-right">
              <Space direction="vertical" className="text-left" size={0}>
                <span className="font-medium">{t("common:powered_by")}</span>
                <img
                  alt="Provider1st Logo"
                  src={window.location.origin + LOGO_SVG_URL}
                />
              </Space>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default Welcome;
